import React, { Fragment } from "react";
import Header from "../components/Header";
import PageHeader from "../components/PageHeader";
import Preview from "../components/Preview";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import SEO from "../components/SEO";

function PreviewPage() {
  return (
    <Fragment>
      <SEO />
      <Header />
      <Preview />
      <Footer />
      <MobileMenu />
    </Fragment>
  );
}

export default PreviewPage;
